/** @jsxImportSource @emotion/react */
import { Button } from "antd";
import React from "react";
import { Images } from "../../common/images";
import * as Styles from "./styles";

interface SideBarLogoComponentProps {
  url: string;
  imageUrl?: string;
  inlineCollapsed: boolean;
  onCollapsedClick: () => void;
}

const SideBarLogoComponent: React.FC<SideBarLogoComponentProps> = ({
  url,
  imageUrl,
  inlineCollapsed,
  onCollapsedClick,
}: SideBarLogoComponentProps) => {
  const onButtonClickHandle = React.useCallback(() => {
    if (onCollapsedClick) {
      onCollapsedClick();
    }
  }, [onCollapsedClick]);

  return (
    <div
      css={
        inlineCollapsed ? Styles.collapsedContainerStyle : Styles.containerStyle
      }
    >
      {!inlineCollapsed && (
        <div>
          <a href={url}>
            <img src={imageUrl} css={Styles.logoImageStyle} />
          </a>
        </div>
      )}
      <Button type="link" onClick={onButtonClickHandle} size="large">
        <img src={inlineCollapsed ? Images.EXPAND : Images.COLLAPSED} />
      </Button>
    </div>
  );
};

export const SideBarLogo = React.memo(SideBarLogoComponent);
